/* eslint-disable global-require */
module.exports = ['component.header.myaccount.m1', 'layouts.header.m8', 'layouts.header.m7', 'layouts.header.m34', 'layouts.header.m4', 'component.header.myaccount.m3', 'account.stripe.customer.protal.button.m1'];
